<ng-container *ngIf="dataSource; else loadingData">
  <va-card>
    <div class="goal-table-header">
      <mat-card-title [ngClass]="{ 'no-subtitle': !tableConfig.header.subtitle }">
        <span>
          {{ tableConfig.header.title.key | translate: tableConfig.header.title.params }}
        </span>
      </mat-card-title>
      <mat-card-subtitle *ngIf="tableConfig.header.subtitle">
        {{ tableConfig.header.subtitle.key | translate: tableConfig.header.subtitle.params }}
      </mat-card-subtitle>
    </div>

    <ng-container class="table-container" *ngIf="dataSource && dataSource.length > 0; else noData">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="goalName">
          <th mat-header-cell *matHeaderCellDef>
            {{ tableConfig.column.headingColumnTitle?.key | translate: tableConfig.column.headingColumnTitle?.params }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="completions">
          <th mat-header-cell *matHeaderCellDef>
            {{ tableConfig.column.columnTitle?.key | translate: tableConfig.column.columnTitle?.params }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.completions }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </ng-container>

    <div *ngIf="footerConfig && footerConfig.locationConfig as locationConfig" class="show-location-container">
      <div class="location-count">
        {{ locationConfig.message?.key | translate: locationConfig.message?.params }}
      </div>
    </div>

    <div *ngIf="footerConfig && footerConfig.dataSourceConfig as sourceConfig">
      <a
        href="{{ sourceConfig.sourceUrl }}"
        *ngIf="sourceConfig.sourceUrl && sourceConfig.sourceUrl !== ''; else noLink"
      >
        <div class="logo">
          <img [src]="sourceConfig.sourceIconUrl" />
        </div>
        <span class="footer-text-container">
          <div class="text-container">
            <div class="tool-tip">
              {{ sourceConfig.sourceTooltip }}
            </div>
            <div class="powered-by" *ngIf="sourceConfig.poweredBy">
              {{ sourceConfig.poweredByI18NDescriptor?.key | translate: sourceConfig.poweredByI18NDescriptor?.params }}
              <strong>{{ sourceConfig.poweredBy }}</strong>
            </div>
          </div>
        </span>
        <mat-icon>open_in_new</mat-icon>
      </a>
      <ng-template #noLink>
        <div class="no-link">
          <div class="logo">
            <img [src]="sourceConfig.sourceIconUrl" />
          </div>
          <span class="footer-text-container">
            <div class="text-container">
              <div class="tool-tip">
                {{ sourceConfig.sourceTooltip }}
              </div>
              <div class="powered-by" *ngIf="sourceConfig.poweredBy">
                {{
                  sourceConfig.poweredByI18NDescriptor?.key | translate: sourceConfig.poweredByI18NDescriptor?.params
                }}
                <strong>{{ sourceConfig.poweredBy }}</strong>
              </div>
            </div>
          </span>
        </div>
      </ng-template>
    </div>

    <ng-template #noData>
      <div class="no-data-container">
        <div class="no-data">
          <mat-icon>bar_chart</mat-icon>
          <h3>No data yet</h3>
        </div>
      </div>
    </ng-template>
  </va-card>
</ng-container>

<ng-template #loadingData>
  <va-card>
    <div class="goal-table-header">
      <mat-card-title>
        <span>
          {{ tableConfig.header.title.key | translate: tableConfig.header.title.params }}
        </span>
      </mat-card-title>
      <mat-card-subtitle>
        <div class="subtitle-line1 stencil-shimmer"></div>
        <div class="subtitle-line2 stencil-shimmer"></div>
        <div class="subtitle-line3 stencil-shimmer"></div>
      </mat-card-subtitle>
    </div>
  </va-card>
</ng-template>
